import {
  ShopOutlined,
  ShoppingCartOutlined,
  HomeOutlined,
  MedicineBoxOutlined,
  BankOutlined,
  CarOutlined,
  BuildOutlined,
  AppstoreOutlined,
  CoffeeOutlined,
  ApartmentOutlined,
  DropboxOutlined,
  FundProjectionScreenOutlined,
} from "@ant-design/icons";
import Slide from "react-reveal/Slide";

const industries = [
  {
    icon: <ShopOutlined />,
    title: "Retail Stores",
    description:
      "Manage stock, sales, customers, and suppliers from one powerful dashboard.",
  },
  {
    icon: <ShoppingCartOutlined />,
    title: "Supermarkets",
    description:
      "Track thousands of products, barcode sales, and inventory in real time.",
  },
  {
    icon: <MedicineBoxOutlined />,
    title: "Pharmacies",
    description:
      "Control medicine inventory, batch numbers, expiry dates, and prescriptions.",
  },
  {
    icon: <CoffeeOutlined />,
    title: "Restaurants & Cafés",
    description:
      "Monitor ingredients, recipes, purchases, sales, and daily stock usage.",
  },
  {
    icon: <ApartmentOutlined />,
    title: "Hotels",
    description:
      "Manage kitchen inventory, housekeeping supplies, and operational expenses.",
  },
  {
    icon: <BuildOutlined />,
    title: "Manufacturing",
    description:
      "Track raw materials, production, finished goods, and warehouse inventory.",
  },
  {
    icon: <DropboxOutlined />,
    title: "Warehouses",
    description:
      "Manage multiple warehouses with transfers, stock counts, and reporting.",
  },
  {
    icon: <CarOutlined />,
    title: "Auto Parts",
    description:
      "Organize spare parts, suppliers, inventory valuation, and sales history.",
  },
  {
    icon: <HomeOutlined />,
    title: "Building Materials",
    description:
      "Track cement, iron rods, paint, plumbing materials, and construction supplies.",
  },
  {
    icon: <BankOutlined />,
    title: "Wholesale & Distribution",
    description:
      "Control bulk inventory, deliveries, customer pricing, and supplier management.",
  },
  {
    icon: <AppstoreOutlined />,
    title: "Electronics Stores",
    description:
      "Manage serial numbers, warranties, inventory movement, and POS sales.",
  },
  {
    icon: <FundProjectionScreenOutlined />,
    title: "Any Growing Business",
    description:
      "SupaRecords adapts to businesses of every size with scalable inventory management.",
  },
];

const InventoryIndustriesComp = () => {
  return (
    <section className="relative overflow-hidden bg-slate-50 py-24">

      {/* Background Decorations */}

      <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-red-100 blur-[150px]" />

      <div className="absolute right-0 bottom-0 h-[420px] w-[420px] rounded-full bg-orange-100 blur-[160px]" />

      <div className="relative max-w-7xl mx-auto px-6">

        <Slide bottom>

          <div className="max-w-3xl mx-auto text-center mb-20">

            <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-5 py-2">

              <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" />

              <span className="text-sm font-semibold text-red-600">
                Industries We Serve
              </span>

            </div>

            <h2 className="mt-8 text-5xl lg:text-6xl font-black leading-tight text-slate-900">

              Built For

              <span className="block bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 bg-clip-text text-transparent">

                Every Business

              </span>

            </h2>

            <p className="mt-8 text-lg leading-8 text-gray-600">

              Whether you're managing one store or multiple branches,
              SupaRecords helps you automate inventory, sales,
              purchasing, accounting, and reporting.

            </p>

          </div>

        </Slide>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

          {industries.map((industry, index) => (

            <Slide bottom key={index}>

              <div className="group rounded-3xl border border-gray-200 bg-white p-8 shadow-lg transition-all duration-300 hover:-translate-y-3 hover:border-red-200 hover:shadow-2xl">

                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-red-600 to-orange-500 text-3xl text-white transition-transform duration-300 group-hover:scale-110">

                  {industry.icon}

                </div>

                <h3 className="mt-8 text-2xl font-bold text-slate-900">

                  {industry.title}

                </h3>

                <p className="mt-4 leading-8 text-gray-600">

                  {industry.description}

                </p>

              </div>

            </Slide>

          ))}

        </div>

        {/* Bottom CTA */}

        <Slide bottom>

          <div className="mt-20 rounded-[36px] bg-gradient-to-r from-red-600 via-red-500 to-orange-500 p-12 text-center text-white">

            <h3 className="text-4xl font-black">

              Don't See Your Industry?

            </h3>

            <p className="mt-5 text-lg opacity-90 max-w-3xl mx-auto">

              No problem! SupaRecords is highly flexible and can be customized
              to fit almost any business that manages inventory, purchases,
              sales, customers, suppliers, or accounting.

            </p>

            <a
              href="https://admin.suparecords.ng/auth/signup"
              target="_blank"
              rel="noreferrer"
              className="mt-10 inline-flex rounded-2xl bg-white px-10 py-4 font-semibold text-red-600 transition hover:scale-105"
            >
              Start Your Free Trial →
            </a>

          </div>

        </Slide>

      </div>

    </section>
  );
};

export default InventoryIndustriesComp;